import type { RegisterableHotkey } from '@tanstack/react-hotkeys'
import { formatForDisplay } from '@tanstack/react-hotkeys'
import type { ComponentProps } from 'react'

export interface KeyboardProps extends Omit<
  ComponentProps<'kbd'>,
  'children' | 'className'
> {
  children: RegisterableHotkey | (string & {})
}

export function Keyboard({ children, ...props }: KeyboardProps) {
  return (
    <kbd
      {...props}
      className="border-tremor-ring bg-tremor-background text-tremor-content-emphasis rounded-md border px-1.5 py-0.5 text-center text-[0.7rem] font-medium whitespace-pre-wrap"
    >
      {formatForDisplay(children)}
    </kbd>
  )
}
